module.exports = __webpack_public_path__ + "static/media/wash_hygiene_map.9e032d35.svg";